import z from "zod";

export const maintenanceFinancialReviewSimpleEntriesRejectSchema = z.object({
  rejected_reason: z.string({ message: 'Campo obrigatório' }).min(8, { message: 'Tamanho mínimo: 8 caracteres' }).max(512, { message: 'Tamanho máximo: 512 caracteres' }),
});

export type MaintenanceFinancialReviewSimpleEntriesRejectSchemaValidationSchema = z.infer<typeof maintenanceFinancialReviewSimpleEntriesRejectSchema>;
